const cookieModal = {
	cookieBtn: document.querySelector('.js-cookie-opener'),

	init: function() {
		this.cookieModal();
		this.closeCookiePopupBtn();
		setTimeout(() => {
			this.cookieBanner();
			this.initialCookieModal();
		}, 500);
	},

	cookieModal: function() {
		if (!this.cookieBtn) return;
		this.cookieBtn.addEventListener('click', (e) => {
			e.preventDefault();
			CookieControl.open();
			// this.appendDivContainer();
			setTimeout(() => {
				this.closeCookiePopupBtn();
			}, 100);
		});
		document.addEventListener('click', (e) => {
			const dismissCookiePopupBtn = document.querySelector(
				'#ccc-dismiss-button'
			);
			if (e.currentTarget.id === '#confirm-btn') {
				dismissCookiePopupBtn.click();
			}
		});
	},

	cookieBanner: function() {
		const cookieBanner = document.querySelector('#ccc-notify');
		if (cookieBanner === null) return;
		document
			.querySelector('.ccc-notify-link')
			?.addEventListener('click', () => {
				setTimeout(() => {
					this.outsideClick();
				}, 500);
			});
	},

	initialCookieModal: function() {
		const cookieNotify = document.querySelector('#ccc-notify');
		if (cookieNotify === null) return;
		document
			.querySelector('.ccc-notify-link')
			?.addEventListener('click', () => {
				// this.appendDivContainer();
				setTimeout(() => {
					this.closeCookiePopupBtn();
				}, 100);
			});
	},

	appendDivContainer: function() {
		const newCookieDiv = document.createElement('div');
		newCookieDiv.classList.add('cookie-inner-div');
		newCookieDiv.innerHTML =
			'<button class=\'cookie-close-btn js-close-cookie-popup\' aria-label=\'Save and close\'><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg><title>Cookie Control Close Icon</title><path d="M1.00195 1L10.9014 10.8995" stroke="white"/><path d="M10.9004 1L1.0009 10.8995" stroke="white"/></svg></svg></button>';
		setTimeout(() => {
			const confirmBtnHolder = document.getElementById('ccc-content');
			if (document.querySelectorAll('.cookie-inner-div').length === 0) {
				confirmBtnHolder.appendChild(newCookieDiv);
			}
		}, 50);
	},

	closeCookiePopupBtn: function() {
		const closeCookiePopupBtnAdditional = document.querySelector(
			'.js-close-cookie-popup'
		);
		const dismissCookiePopupBtn = document.querySelector(
			'#ccc-dismiss-button'
		);
		if (closeCookiePopupBtnAdditional === null) return;
		closeCookiePopupBtnAdditional.addEventListener('click', () => {
			dismissCookiePopupBtn.click();
		});
	},

	outsideClick: function() {
		document.addEventListener('click', (e) => {
			const cookieOverlay = document.getElementById('ccc-content');
			if (e.target === document.querySelector('.js-cookie-opener')) {
				return;
			}
			if (!cookieOverlay) return;
			const dismissCookiePopupBtn = document.querySelector(
				'#ccc-dismiss-button'
			);
			if (!cookieOverlay.contains(e.target)) {
				dismissCookiePopupBtn.click();
			}
		});
	},
};

export default cookieModal;
